<style scoped>
    .v-progress-circular {
        margin: 1rem;
    }
</style>

<template>
  <div>
    <Badge :value="Status" :style="{'background-color':Color}"></Badge>
  </div>
</template>

<script>

  import Badge from 'primevue/badge';

    export default  {
    name: 'RenderAssessmentStatus',
    components: {Badge}
,
    data: () => ({
        Icon: '',
        Color: '',
        Status: '',
        ShowProgress:false
    }),
        created() {
            this.Status = this.params.value;

            if (this.params.data.typeCode == "SRTD") {
                this.Color = "#558B2F"
                this.Icon = "mdi-circle-slice-3"
            }
            if (this.params.data.typeCode == "INPG") {
                this.Color = "#00897B"
                this.ShowProgress = true
                this.Icon = ""
            }
            if (this.params.data.typeCode == "CMP") {
                this.Color = "#A5D6A7"
                this.Icon = "mdi-check-bold"
            }
            if (this.params.data.typeCode == "DFT") {
                this.Color = "#90A4AE"
                this.Icon = "mdi-folder-cog-outline"
            }
            if (this.params.data.typeCode == "ARC") {
                this.Color = "#0277BD"
                this.Icon = "mdi-archive-arrow-up-outline"
            }
            if (this.params.data.typeCode == "REV") {
                this.Color = "#FFCC80"
                this.Icon = "mdi-magnify-scan"
            }
            if (this.params.data.typeCode == "PENDREV") {
                this.Color = "#FF7043"
                this.Icon = "mdi-notebook-check-outline"
            }

            if (this.params.data.typeCode == "RTST") {
                this.Color = "#26C6DA"
                this.Icon = "mdi-thumb-up-outline"
            }
        }
    };
</script>